import { render } from "./Pagination.vue?vue&type=template&id=27525329&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=27525329&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20241218.110742/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27525329"]])

export default __exports__